module.exports = __webpack_public_path__ + "img/tiktok-logo-white.d2784844.svg";